import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { forgotPassword } from '../service/PasswordResetService';
import './Login.scss';

const ForgotPassword = () => {
    const toast = useRef(null);
    const navigate = useNavigate();
    const [usuarioOEmail, setUsuarioOEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [enviado, setEnviado] = useState(false);

    const handleEnviar = async () => {
        if (!usuarioOEmail.trim()) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Completá tu usuario o email', life: 4000 });
            return;
        }

        setSubmitting(true);
        try {
            await forgotPassword(usuarioOEmail.trim());
        } catch {
            // El backend siempre responde 200 con mensaje generico; si falla la red,
            // igual mostramos el mismo mensaje para no revelar nada sobre la cuenta.
        } finally {
            setSubmitting(false);
            setEnviado(true);
        }
    };

    const handleKeyUpEnter = (e) => {
        if (e.key === 'Enter') handleEnviar();
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="ef-login">
                <div className="ef-login-visual">
                    <img className="ef-login-bg" src="assets/layout/images/pages/login.jpg" alt="" />
                    <div className="ef-login-overlay"></div>

                    <div className="ef-login-brand">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <path d="M3 12L12 4L21 12" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 11V20H18V11" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span>EXPENSAS<b>360</b></span>
                    </div>

                    <div className="ef-login-headline">
                        <h1>Todo tu barrio,<br />en un solo panel.</h1>
                        <p>Gestioná expensas, pagos y comunicación con tus vecinos de forma simple, desde cualquier lugar.</p>
                    </div>
                </div>

                <div className="ef-login-panel">
                    <div className="ef-login-panel-inner">
                        <img className="ef-login-logo" src="./assets/layout/images/ab/expensas360.png" alt="Expensas360" />

                        <h2 className="ef-login-title">Recuperar contraseña</h2>

                        {enviado ? (
                            <>
                                <p className="ef-login-subtitle">
                                    Si el usuario existe, te enviamos un mail con instrucciones para restablecer tu contraseña. Revisá tu bandeja de entrada (y spam).
                                </p>
                                <Button
                                    type="button"
                                    label="Volver a iniciar sesión"
                                    className="ef-login-submit"
                                    onClick={() => navigate('/login')}
                                />
                            </>
                        ) : (
                            <>
                                <p className="ef-login-subtitle">Ingresá tu usuario o email y te mandamos un link para restablecerla</p>

                                <div className="ef-login-field">
                                    <label htmlFor="usuarioOEmail">Usuario o email</label>
                                    <div className="ef-login-input-wrap">
                                        <InputText
                                            id="usuarioOEmail"
                                            type="text"
                                            className="ef-login-input"
                                            value={usuarioOEmail}
                                            onChange={e => setUsuarioOEmail(e.target.value)}
                                            onKeyUp={handleKeyUpEnter}
                                        />
                                    </div>
                                </div>

                                <Button
                                    type="button"
                                    label="Enviar"
                                    className="ef-login-submit"
                                    loading={submitting}
                                    onClick={handleEnviar}
                                />

                                <p className="ef-login-signup">
                                    <button type="button" className="ef-login-link" onClick={() => navigate('/login')}>Volver a iniciar sesión</button>
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
